import React, { FormEvent, useContext } from "react";
import { useState } from "react";
import { Row, Col, Card, Container, Button } from "react-bootstrap";
import { abpnClient } from "../../Services/AbpnClient";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import ActionResultMessage from "../Shared/Components/ActionResultMessage";
import HeaderWithTitle from "../Shared/Components/HeaderWithTitle";
import { ActionResult } from "../Shared/Models/ActionResult";
import AccountAssistance from "./AccountAssistance";
import { AuthContext } from "./AuthProvider";
import ActivateUser from "./Models/ActivateUser";
import SearchPhysicianModel, { MatchPhysicianResult } from "./Models/SearchPhysicianModel";
import SearchPhysician from "./SearchPhysician";
import UpdateEmail from "./UpdateEmail";
import ActivationSelectExam from "./ActivationSelectExam";

export default function SearchForAccount() {
    const [matchResult, setMatchResult] = useState<MatchPhysicianResult>(null);
    const [model, setModel] = useState<SearchPhysicianModel>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [alert, setAlert] = useState<ActionResult>(null);
    const [hasCompletedResidency, setHasCompletedResidency] = useState(null);
    const [noExamsAvailable, setNoExamsAvailable] = useState(null);
    const authContext = useContext(AuthContext);


    const allowUpdateEmail = matchResult != null && matchResult.isExactMatch && !matchResult.requiresAccountAssistance;
    const showExamSelection = matchResult?.requiresAccountAssistance || hasCompletedResidency === false;
    const showAccountAssistance = matchResult?.requiresAccountAssistance || hasCompletedResidency;
    const showResidency = !matchResult?.isExactMatch && !matchResult?.requiresAccountAssistance && hasCompletedResidency === null && model != null;
    const showSearchAgain = !matchResult?.isExactMatch || hasCompletedResidency;

    const matchPhysician = (e: FormEvent<HTMLFormElement>, model: SearchPhysicianModel) => {
        e.preventDefault();
        e.stopPropagation();
        if (!model.siteToken) return;

        e.currentTarget.classList.add('was-validated');
        if (e.currentTarget.checkValidity()) {
            e.currentTarget.classList.remove('was-validated');
            setModel(model);
            setIsLoading(true);

            abpnClient.post<MatchPhysicianResult>('/api/profile/MatchPhysician', model, null)
                .then(result => {
                    setMatchResult(result);
                    setIsLoading(false);
                })
        }
    }

    const searchAgain = () => {
        setModel(null);
        setMatchResult(null);
        setHasCompletedResidency(null);
    }

    const registerUserAccount = async (userModel: ActivateUser) => {
        setIsLoading(true);

        await abpnClient.post<void>('/api/profile/activate', userModel, null);
        await authContext.register(userModel);

        var newAlert = new ActionResult();
        newAlert.title = `"Create Password" Email Sent`;
        newAlert.alertType = "pp-alert-success";
        newAlert.message = `Please check your ${userModel.email} email account and follow instructions to create your new password within 24 hours.`;

        setAlert(newAlert);
        setIsLoading(false);
    }

    if (isLoading) return <AbpnSpinner />
    if (alert) return <ActionResultMessage title={alert.title} subTitle={null} alertVariant={alert.alertType} message={alert.message} />
    if (showAccountAssistance) return <AccountAssistance
        showSearchAgain={showSearchAgain}
        showLogin={true}
        searchAgain={searchAgain}
        hascompletedResidency={hasCompletedResidency}></AccountAssistance>
    return (
        <Container>
            {model == null && <HeaderWithTitle title="Search For Account" subTitle={null} contactMessage={false} />}
            {allowUpdateEmail && <HeaderWithTitle title="Enter Personal Email Address" subTitle={null} contactMessage={false} />}
            {showExamSelection && !noExamsAvailable && <HeaderWithTitle title="Select Examination" subTitle={null} contactMessage={false} />}
            {showResidency && <HeaderWithTitle title="Residency" subTitle={null} contactMessage={false} />}
            {noExamsAvailable && <HeaderWithTitle title="Examination Applications Currently Unavailable" subTitle={null} contactMessage={false} />}
            <Card className="mb-3" border="pp-secondary-grey">
                <Card.Body>
                    <Row>
                        <Col>
                            {model == null && <SearchPhysician onSubmit={matchPhysician} />}

                        </Col>
                    </Row>
                    {matchResult != null &&
                        <Row>
                            <Col>

                                {/* Match on 3  */}
                                {allowUpdateEmail &&
                                    <UpdateEmail model={model} onSave={registerUserAccount} />
                                }

                                {/* Match on < 2 */}
                                {showResidency && (
                                    <React.Fragment>
                                        <Row>
                                            <Col>
                                                <Card.Text className="pp-font-size-smaller">Will you complete or have you completed training in a US ACGME-accredited residency program in 2012 or later?</Card.Text>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button variant="pp-primary" className="mt-4" type="button" onClick={() => setHasCompletedResidency(true)}>Yes</Button>
                                                {<Button variant="outline-pp-primary" className="mt-4 ml-2" type="button" onClick={() => setHasCompletedResidency(false)}>No</Button>}
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                )}

                                {showExamSelection &&
                                    <ActivationSelectExam searchModel={model} reportNoExams={() => setNoExamsAvailable(true)} />
                                }
                            </Col>
                        </Row>
                    }
                </Card.Body>
            </Card>
        </Container>
    );
}
